import * as React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { EntityActions, EntityType } from 'common/entity';

import { AppState } from 'common/models/AppState';
import { FormAutosuggestMember } from 'common/components/form/FormAutosuggestMember';
import { Formik } from 'formik';
import { formatFullname } from 'common/utils/format';

interface AddEmployeeDialogProps {
  appState: AppState;
  entityActions: EntityActions;
  isOpen?: boolean;
  onSave: (id: string) => void;
  onCancel: () => void;
}
interface AddEmployeeDialogState {
  userId?: string;
}
interface AddEmployeeValues {}

export class AddEmployeeDialog extends React.Component<AddEmployeeDialogProps, AddEmployeeDialogState> {
  state: AddEmployeeDialogState = { userId: undefined };

  componentDidUpdate(prevProps: AddEmployeeDialogProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ userId: undefined });
    }
  }

  initialValues() {
    return {};
  }

  handleSubmit = (values: AddEmployeeValues) => {
    this.props.onSave(this.state.userId!);
  };

  handleChangeUser = (field: string, memberId: string) => {
    this.props.entityActions.refetch(EntityType.MEMBER, memberId);
    this.setState({ userId: memberId });
  };

  render() {
    return (
      <Modal size="md" isOpen={!!this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={form => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>Add Employee</ModalHeader>
              <ModalBody>
                {!this.state.userId && (
                  <div className="row">
                    <div className="col">
                      <FormAutosuggestMember
                        id="user"
                        appState={this.props.appState}
                        onChange={this.handleChangeUser}
                        type="user"
                        autoFocus={true}
                      />
                    </div>
                  </div>
                )}
                {this.state.userId && (
                  <div className="row" style={{ marginTop: 5 }}>
                    <div className="col">
                      Are you sure you want to add{' '}
                      <b>{formatFullname(this.props.appState.entities.member[this.state.userId])}</b> to the
                      organization?
                    </div>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit" disabled={!this.state.userId}>
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orgs/AddEmployeeDialog.tsx